import React from 'react';
import { FileText } from 'lucide-react';

interface DealStep1BillingEmptyProps {
  language: string;
}

/**
 * Step 1 tab "Fatturazione" — empty state Notion-like.
 *
 * Le impostazioni billing dettagliate (fattura unica con righe multiple)
 * sono renderizzate dentro Step 2, perché richiedono almeno un servizio
 * o prodotto in carrello. Senza questo placeholder il tab mostrava una
 * pagina completamente bianca.
 */
export function DealStep1BillingEmpty({ language }: DealStep1BillingEmptyProps) {
  return (
    <div className="flex-1 overflow-hidden p-4">
      <div className="max-w-xl mx-auto mt-12">
        <div className="text-center py-10 px-4 flex flex-col items-center justify-center gap-3">
          <div className="w-10 h-10 rounded-full bg-black/[0.04] dark:bg-white/[0.06] flex items-center justify-center">
            <FileText size={18} className="text-black/40 dark:text-white/40" />
          </div>
          <div className="text-[13px] font-medium text-black/70 dark:text-white/70">
            {language === 'it' ? 'Impostazioni di fatturazione' : 'Billing settings'}
          </div>
          <p className="text-[12px] text-black/45 dark:text-white/45 max-w-[360px]">
            {language === 'it'
              ? "Le opzioni di fatturazione (es. fattura unica con righe multiple) compaiono nello step 2 una volta che hai aggiunto almeno un servizio o prodotto all'offerta."
              : 'Billing options (e.g. single invoice with multiple lines) appear in step 2 once you have added at least one service or product to the deal.'}
          </p>
        </div>
      </div>
    </div>
  );
}
